$.fn.truncated = function(offset = 0) {
  let self = this
  self.truncated = true;
  self.wrapper = $('<div class="js-truncated-wrapper"/>')
  self.wrapAll(self.wrapper);
  self.toggle = $('<button class="js-truncated__toggle"><span class="show-more">' + bassaintlaurent_l10n.SHOW_MORE + '</span><span class="show-less">' + bassaintlaurent_l10n.SHOW_LESS + '</span></button>');
  self.toggle.click(function() {
    self.toggleClass('--expanded')
  })
  self.after(self.toggle);
  self.last = $('<span class="js-truncated__last">|</span>')
  self.find('p:last-child').append(self.last);

  self.init = function() {
    self.removeClass('--truncable')
    self.contentHeight = self.last.offset().top - self.offset().top + self.last.height();
    if (self.contentHeight > self.outerHeight()) {
      self.addClass('--truncable')
    } else {
      self.removeClass('--truncable')
    }
  }

  return function() {
    self.init();
    $(window).on('resize orientationchange load', self.init)
    return self
  }()
};
